<template>
  <div id="app">
<!--
  <img src="./assets/logo.png">
-->
  <router-view/>
  </div>
</template>

<script>
  import App from "./App.ts"

  export default App;
</script>

<style>
  @import "./assets/css/jybe.css";
  @import "./assets/w3css/w3.css";
  @import "./assets/w3css/w3-theme-blue-grey.css";
  @import "./assets/w3css/google-fonts.css";
  @import "./assets/fontawesome/css/fontawesome-all.css";
  @import "./assets/googlefonts/css/gf.css";
</style>
